// extracted by mini-css-extract-plugin
export default {"container":"mockHostApp_container__OeUB7","error":"mockHostApp_error__dxc+b"};